import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9e9fefcc")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "sound-muting flex items-center justify-center",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSound && _ctx.toggleSound(...args)))
  }, [
    _createVNode("img", {
      src: require(`@/assets/images/${_ctx.soundOn ? 'sound' : 'muted'}.svg`),
      alt: _ctx.soundOn ? 'Mute sound' : 'Unmute sound'
    }, null, 8, ["src", "alt"])
  ]))
})